import { FirebaseContext } from '../../../context/firebase';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import * as STORAGE_BUCKET from '../../../constants/storageBucket';
import * as PROJECT_CODE from '../../../constants/projectCode';

export async function GetExteriorImage(unitId, exteriorImageId){

    const { firebase } = useContext(FirebaseContext);

    var exteriorImgRef = firebase.storage().refFromURL(
        'gs://' +
            STORAGE_BUCKET.storageBucket +
            '.appspot.com/' +
            PROJECT_CODE.projectCode +
            '/unityWebUi/units/' +
            unitId +
            '.jpg'
    );

    var thisUrl;
    await exteriorImgRef.getDownloadURL().then((url) => {
        console.log(url);
        //callback(url);
        thisUrl = url;
    })

    //console.log("returned url ", thisUrl);

    var thisImage = document.getElementById(exteriorImageId);

    //console.log("This image " + thisImage.id);

    thisImage.src = thisUrl;

    return thisUrl;
}

export async function GetInteriorImage( unitId, roomId, interiorImageId){

    const { firebase } = useContext(FirebaseContext);

    var exteriorImgRef = firebase.storage().refFromURL(
        'gs://' +
            STORAGE_BUCKET.storageBucket +
            '.appspot.com/' +
            PROJECT_CODE.projectCode +
            '/unityWebUi/rooms/' +
            unitId + roomId +
            '.jpg'
    );

    var thisUrl;
    await exteriorImgRef.getDownloadURL().then((url) => {
        console.log(url);
        //callback(url);
        thisUrl = url;
    })

    //console.log("returned url ", thisUrl);

    var thisImage = document.getElementById(interiorImageId);

    //console.log("This image " + thisImage.id);

    thisImage.src = thisUrl;

    return thisUrl;
}

export async function GetUpgradeImage( upgradeId, upgradeImageId){

    const { firebase } = useContext(FirebaseContext);

    var exteriorImgRef = firebase.storage().refFromURL(
        'gs://' +
            STORAGE_BUCKET.storageBucket +
            '.appspot.com/' +
            PROJECT_CODE.projectCode +
            '/unityWebUi/upgrades/' +
            upgradeId +
            '.jpg'
    );

    var thisUrl;
    await exteriorImgRef.getDownloadURL().then((url) => {
        console.log(url);
        //callback(url);
        thisUrl = url;
    })

    //console.log("returned url ", thisUrl);

    var thisImage = document.getElementById(upgradeImageId);

    //console.log("This image " + thisImage.id);

    thisImage.src = thisUrl;

    return thisUrl;
}

export async function GetFloorImage(floorImageId, firebase){



    var exteriorImgRef = firebase.storage().refFromURL(
        'gs://' +
            STORAGE_BUCKET.storageBucket +
            '.appspot.com/' +
            PROJECT_CODE.projectCode +
            '/unityWebUi/floorplans/' +
            floorImageId +
            '.jpg'
    );

    var thisUrl;
    await exteriorImgRef.getDownloadURL().then((url) => {
        console.log(url);
        //callback(url);
        thisUrl = url;
    })

    //console.log("returned url ", thisUrl);

    return thisUrl;
}